import React from "react";
import PropTypes from "prop-types";

import ReactDatePicker from "react-datepicker";

import "./DateRange.scss";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap-daterangepicker/daterangepicker.css";

const DatePicker = ({
    selected,
    onChange,
    placeholder,
    onBlur,
    isDisable
}) => {
    const handleButtonClick = (e) => {
        if (onChange) {
            onChange(e);
        }
    };

    return (
        <div className="date-picker">
            <ReactDatePicker
                placeholderText={placeholder}
                // value={selected}
                selected={selected}
                onChange={(e) => handleButtonClick(e)}
                onBlur={onBlur}
                autoComplete="off"
                disabled={isDisable}
            />
        </div>
    );
};

DatePicker.propTypes = {
    selected: PropTypes.instanceOf(Date),
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    onBlur: PropTypes.func,
    isDisable: PropTypes.bool,
};
export default DatePicker;
